import React from 'react'
import { Col, Row, Stack } from 'react-bootstrap'
import { useOutletContext } from 'react-router-dom'
import type { ReactNode } from 'react'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { PageTitle } from '../PageTitle'
import styles from './FixedPage.module.scss'

type FixedPageHeaderProps = {
  title?: ReactNode
  description?: string
  actions?: React.ReactNode
  breadcrumbs?: React.ReactNode
  siteName?: string
}
export type OutletContext = {
  noTopMargin?: boolean
}

export const FixedPageHeader = ({ title, description, actions, breadcrumbs, siteName }: FixedPageHeaderProps) => {
  const outletContext = useOutletContext<OutletContext>()

  // `top` is the sticky offset from the top of the scroll container — the default (CSS) 60px
  // clears the app's `position: fixed` navbar via each app's own `#main { margin-top: 60px }`
  // rule (e.g. `apps/panelpunches/admin/src/assets/css/style.css`), which already pushes this
  // header's static (unstuck) position down to that same 60px — so no extra flow space needs
  // reserving here. `RouteOffCanvas` passes `noTopMargin` because its panel has no navbar and no
  // such margin, so this header sticks to its own container's top (0) instead.
  const stickyTop = outletContext?.noTopMargin === true ? 0 : undefined

  return (
    <div className={`${styles.fixedHeaderTop} d-flex flex-shrink-0`} style={{ top: stickyTop }}>
      <HorizontalStack className="justify-content-between flex-fill">
        <Stack>
          <Row>
            <Col sm={12} md={6} className="align-self-center">
              <Stack>
                <div>
                  <ShowIf condition={!!title}>
                    <PageTitle title={title} siteName={siteName} noTitleTag />
                  </ShowIf>
                  <ShowIf condition={!!description}>
                    <small>{description}</small>
                  </ShowIf>
                  {breadcrumbs}
                </div>
              </Stack>
            </Col>
            <Col sm={12} md={6}>
              <div>
                <HorizontalStack className="justify-content-lg-end">
                  <ShowIf condition={!!actions}>
                    <div className="title-action">{actions}</div>
                  </ShowIf>
                </HorizontalStack>
              </div>
            </Col>
          </Row>
        </Stack>
      </HorizontalStack>
    </div>
  )
}
